
import { Link } from 'react-router-dom';

export default function VenuesListFooter() {
  return (
    <footer className="bg-stone-100 text-gray-800 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/8e563ca5-c856-4df8-ac33-ff016d92cfb7.png"
                alt="日本音楽会場協会 東京クラブ"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-sm text-gray-500 leading-relaxed">
              日本音楽会場協会 東京クラブは、地域の音楽シーンを支え、発展させるために活動しています。
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-gray-900">
              <a href="/#activities" className="hover:opacity-70 transition-opacity">クイックリンク</a>
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/" className="hover:text-gray-900 transition-colors cursor-pointer">トップページ</Link></li>
              <li><a href="/#venues" className="hover:text-gray-900 transition-colors cursor-pointer">参加会場</a></li>
              <li><a href="/#artists" className="hover:text-gray-900 transition-colors cursor-pointer">登録アーティスト</a></li>
              <li><a href="/#schedule" className="hover:text-gray-900 transition-colors cursor-pointer">ライブスケジュール</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-gray-900">お問い合わせ</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5"></i>
                <span>東京都渋谷区宇田川町15-1</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>03-1234-5678</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>info@tokyo-club.jp</span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-gray-900">営業時間</h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li>月曜日 - 金曜日</li>
              <li>10:00 - 18:00</li>
              <li className="pt-2">土曜日・日曜日・祝日</li>
              <li>休業</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-400">
            &copy; 2025 日本音楽会場協会 東京クラブ. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
